// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import { FormUpload } from './FormUpload';
  
  export default {
    path: 'arquivos',
    name: 'Arquivos',
    childRoutes: [
      { path: 'upload', name: 'Upload', component: FormUpload, isIndex: true },
    ],
  };
  


// WEBPACK FOOTER //
// ./src/features/arquivos/route.js